import { FormattedMessage, injectIntl } from 'react-intl';
import React, {
  useState,
  useEffect,
  useContext,
  useRef,
  useImperativeHandle,
} from 'react';
import { Form, Input, Row, Col, Select, Button } from 'antd';
import myContext from '@/utils/createContext';
import { getUrlParams, gtag } from '@/utils/index.js';
import paypalAddress from '@/components/Common/NewAddress/paypalAddress.json';
import klarnaAddress from '@/components/Common/NewAddress/klarna_Address.json';
import { postalCodeData } from '@/components/Common/NewAddress/postalCodeData.js';

import _ from 'lodash';
import FloatLabel from '@/components/H5PC/Form/FloatLabel/index.js';
const { TextArea } = Input;
const key = getUrlParams('key');

const FormItem = Form.Item;
const { Option } = Select;

const Address = props => {
  const intl = props.intl;
  const type = props.type;
  const { formatMessage } = intl;
  const countryRef = useRef();
  const line1Ref = useRef();
  const line2Ref = useRef();
  const districtRef = useRef();
  const cityRef = useRef();
  const stateRef = useRef();
  const postcodeRef = useRef();
  const { form, initData, isMobileView, radioValue, showDomain } = useContext(myContext);

  const h5OrWeb = isMobileView ? 'H5' : 'WEB';
  const paymentMethod = localStorage.getItem('paymentMethod');
  let {
    needBillingAddress,
    cardCountry,
    cardLine1,
    cardLine2,
    cardDistrict,
    cardCity,
    cardState,
    cardPostcode,
    kbaCountryList
  } = initData || {};

  const [myCardCountry, setMyCardCountry] = useState('cardCountry' || '');
  const [myCardLine1, setMyCardLine1] = useState(cardLine1 || '');
  const [myCardLine2, setMyCardLine2] = useState(cardLine2 || '');
  const [myCardCity, setMyCardCity] = useState(cardCity || []);
  const [myCardState, setMyCardState] = useState(cardState || []);
  const [myCardPostcode, setMyCardPostcode] = useState(cardPostcode || []);
  const [myAllAddress, setMyAllAddress] = useState('');
  const [addressEditable, setAddressEditable] = useState(false);
  const [beforePostcodeVal, setBeforePostcodeVal] = useState('');
  const [hideAllAddress, setHideAllAddress] = useState(false); // 隐藏地址
  const [myNeedBillingAddress, setMyNeedBillingAddress] = useState(
    needBillingAddress || false,
  ); // 隐藏地址
  useEffect(() => {
    form.setFieldsValue({
      cardCountry,
      cardLine1,
      cardLine2,
      cardDistrict,
      cardCity,
      cardState,
      cardPostcode,
    });
    if (radioValue === 'LCR' || radioValue === 'ICR') {
      if (
        !_.isEmpty(cardCountry) &&
        !_.isEmpty(cardLine1) &&
        // !_.isEmpty(cardLine2) &&
        !_.isEmpty(cardCity) &&
        !_.isEmpty(cardState) &&
        !_.isEmpty(cardPostcode)
      ) {
        // 不考虑是否匹配到，暂时一股脑的给后端，比如北京：本来应该传BEIJING，现在传了BJ
        setHideAllAddress(true);
        setMyNeedBillingAddress(false);
      } else {
        setHideAllAddress(false);
        setMyNeedBillingAddress(true);
      }
    } else if (radioValue === 'BOL') {
      if (
        !_.isEmpty(cardCountry) &&
        !_.isEmpty(cardLine1) &&
        // !_.isEmpty(cardLine2) &&
        // !_.isEmpty(cardDistrict) &&
        !_.isEmpty(cardCity) &&
        !_.isEmpty(cardState) &&
        !_.isEmpty(cardPostcode)
      ) {
        // 不考虑是否匹配到，暂时一股脑的给后端，比如北京：本来应该传BEIJING，现在传了BJ
        setHideAllAddress(true);
        setMyNeedBillingAddress(false);
      } else {
        setHideAllAddress(false);
        setMyNeedBillingAddress(true);
      }
    } else if (radioValue === 'PIX') {      
      // 1、needBillingAddress=true & 账单信息完整 false 
      // 2、needBillingAddress=true & 账单信息不完整  true          
      // 3、needBillingAddress=false & 账单信息不完整  false
      // 4、needBillingAddress=false & 账单信息完整 false
      if (
        needBillingAddress &&
        !_.isEmpty(cardCountry) &&
        !_.isEmpty(cardLine1) &&
        !_.isEmpty(cardCity) &&
        !_.isEmpty(cardState) &&
        !_.isEmpty(cardPostcode)
      ) {       
        setHideAllAddress(true);
        setMyNeedBillingAddress(false);
      } else {
        //账单地址模块是否显示与接口出参needBillingAddress值保持一致
        setHideAllAddress(!needBillingAddress);
        setMyNeedBillingAddress(needBillingAddress);
      }
    } else if (radioValue === 'KBA' ) {
      if (
        !_.isEmpty(cardCity) &&
        !_.isEmpty(cardCountry) &&
        !_.isEmpty(cardLine1) &&
        !_.isEmpty(cardPostcode)
      ) {
        // 不考虑是否匹配到，暂时一股脑的给后端，比如北京：本来应该传BEIJING，现在传了BJ
        setHideAllAddress(true);
        setMyNeedBillingAddress(false);
      } else {
        setHideAllAddress(false);
        setMyNeedBillingAddress(true);
      }
    }
    // 如果国家所有的信息都存在，则隐藏
  }, [initData]);
  // "line1Label": "Address line 1",
  // "line2Label": "Address line 2",
  // "cityLabel": "City",
  // "selectLabel": "Select",
  // "stateLabel": "Province",
  // "stateList":[]
  // "postcodeLabel": "Postcode",
  // "optionalLabel": "(optional)",
  // todo
  /**
   * territory --> 获取code和name，根据code到addressEntry的strings下面匹配信息
   // country  -- 选择 【必填】 2位
  // line1  -- 填写【必填】   256位
  // line2 -- 【非必填】      256位
  // city  -- 填写 【必填】   64位
  // state -- 选或填 【非必填】  64位
  // postcode --填写 【必填】  32位
   *  注意如果有validationError，则是postcode的二级错误
   */
  const [countryList, setCountryList] = useState([]); // 国家
  // const [country, setCountry] = useState(''); // 国家
  const [countryLabel, setCountryLabel] = useState(''); // 国家Label
  const [line1Label, setLine1Label] = useState(''); // 地址1的label
  const [line2Label, setLine2Label] = useState(''); // 地址2的label
  const [districtLabel, setDistrictLabel] = useState(''); // 地址2的label
  const [cityLabel, setCityLabel] = useState(''); // 城市的label
  const [selectLabel, setSelectLabel] = useState(''); // 州是否为可选的字段
  const [stateLabel, setStateLabel] = useState(''); // 州的label
  const [cityList, setCityList] = useState([]); // 城市的列表 HK/TR/TW 等
  const [stateList, setStateList] = useState([]); // 州的列表
  const [postcodeLabel, setPostcodeLabel] = useState(''); // 邮编的label
  const [postcodeRegex, setPostcodeRegex] = useState(''); // 根据国家匹配正确的邮编的正则
  const [validationError, setValidationError] = useState(''); // 邮编的label
  const [hideOtherLabel, setHideOtherLabel] = useState(false); // 邮编的label

  // 以下为特殊国家，需要单独处理
  // United Arab Emirates --> AE 邮编为00000
  // Qatar --> QA 邮编为00000
  // Zimbabwe --> ZW 邮编为00000
  // Hong Kong SAR China --> HK A999077
  const specialAllCountryArr = ['AE', 'QA', 'ZW', 'HK'];
  // useEffect(() => {
  //   // form.setFieldsValue({ allAddress: myAddress });
  //   const territory = paypalAddress.territory;
  //   setCountryList(territory);
  //   // 如果后端传过来的数据cardCountry不存在或者不在领土列表中，则需要手填数据
  // }, []);

  useEffect(() => {
    const territory = paypalAddress.territory;
    switch(paymentMethod) {
      case 'kba':
        //Klarna支付可支持国家 
        //const KlarnaSupportCountryList = ['AT','DE','DK','FI','GB','NL','NO','SE', 'BE','IT','ES','FR','PT','CH', 'PL'];
        // 账单地址选择国家，取决于创单传入的支付币种，关系如下：
        // - EUR的可选国家为Finland芬兰（FI）/Germany 德国（DE）/Austria 奥地利（AT）/Netherlands 荷兰（NL）/Belgium 比利时（BE）/Italy 意大利（IT）/Spain 西班牙（ES）/France 法国（FR）/Portugal 葡萄牙（PT），
        // - SEK的可选国家为Sweden 瑞典 SE，
        // - NOK的可选国家为Norway 挪威 NO，
        // - DKK的可选国家为Denmark 丹麦 DK，
        // - GBP的可选国家为United Kingdom 英国（GB）， 
        // - CHF的可选国家为Switzerland 瑞士 CH，
        // - PLN的可选国家为Poland 波兰 PL，
        const filtered =_.filter(territory, p => _.includes(kbaCountryList||[], p.code));
        setCountryList(filtered);
        break;
      default:
        setCountryList(territory);
    } 
       
    const isFind = _.find(territory, function(o) {
      return o.code === cardCountry;
    });
    /**三种逻辑
     * 逻辑1，传递了国家cardCounry并且在Paypal中找到的
     * 逻辑2，传递了国家cardCounry在Paypal中未找到
     * 逻辑3，未传递国家cardCounry
     */
    if (!_.isEmpty(isFind)) {
      // 如果找到了
      setAddressEditable(false);
      gtag(`${showDomain}支付页面`, [new Date() + '地址已自动填充']);
      gtag(`${showDomain}支付页面`, ['地址已自动填充']);
      showDomain ? gtag(`定制支付页面`, ['地址已自动填充']):'';
      
    } else {
      // todo @埋点
      // window.gtag('event', '支付页面', {
      //   event_category: `${h5OrWeb}收银台`,
      //   event_label: '收货地址转账单地址错误',
      //   value: '',
      // });
      if (cardCountry) {
        gtag(`${showDomain}支付页面`, [new Date() + '不能转化的国家代码' + cardCountry]);
        gtag(`${showDomain}支付页面`, ['不能转化的国家代码'+cardCountry]);
        showDomain ? gtag(`定制支付页面`, ['不能转化的国家代码'+cardCountry]):'';

      }
      form.setFieldsValue({
        cardCountry: '',
        cardLine1: '',
        cardLine2: '',
      });
      resetAll();
      setAddressEditable(true);
    }
    // console.log('cardCountry', cardCountry);
    // 首次需要设置label值，需要根据paypal地址匹配
    setAllLabelValue(cardCountry);
  }, [initData]);

  useEffect(() => {
    // 动态更改巴西label
    setAllLabelValue(myCardCountry);
  }, [intl.locale]);

  const resetAll = () => {
    // 重置context中的数据
    setMyCardLine1('');
    setMyCardLine2('');
    setMyCardCity('');
    setMyCardState('');
    setMyCardPostcode('');
    // 初始化
    setLine1Label('');
    setLine2Label('');
    setDistrictLabel('');
    setCityLabel('');
    setPostcodeLabel('');
    setSelectLabel('');
    setStateLabel('');
    setCityList([]);
    setStateList([]);
    setPostcodeRegex('');
    form.setFieldsValue({
      cardCity: '',
      cardState: '',
      cardPostcode: '',
    });
  };
  // 首次加载，设置label默认值
  const setAllLabelValue = value => {
    // 如果没有传国家的情况，则直接返回
    if (_.isEmpty(value)) {
      setMyCardCountry('');
      return;
    }

    // United Arab Emirates --> AE 邮编为00000
    // Qatar --> QA 邮编为00000
    // Zimbabwe --> ZW 邮编为00000
    // Hong Kong SAR China --> HK A999077

    const specialCountryArr = ['AE', 'QA', 'ZW'];
    if (specialCountryArr.includes(value)) {
      form.setFieldsValue({
        cardPostcode: '00000',
      });
    }
    if (value === 'HK') {
      form.setFieldsValue({
        cardPostcode: 'A999077',
      });
    }
    // 根据国家获取对应的addressEntry中的值 和 邮编postalCode的正则
    const address = paymentMethod === 'kba' ? klarnaAddress.addressEntry.strings[value] : paypalAddress.addressEntry.strings[value];
    if (!address) {
      // 隐藏所有的，同时调整countrylabel
      setRefChange(countryRef);
    } else {
      let {
        cityLabel,
        line1Label,
        line2Label,
        postcodeLabel,
        selectLabel,
        stateLabel,
        stateList,
        cityList,
        validationError,
      } = address;
      // let countryLabel;
      let districtLabel;

      // if (value === 'BR') { 
        // countryLabel = formatMessage({ id: 'ga-checkout.address.country' });
        cityLabel = formatMessage({ id: 'ga-checkout.address.city' });
        line1Label = formatMessage({ id: 'ga-checkout.address.line1' });
        line2Label = formatMessage({ id: 'ga-checkout.address.line2' });
        districtLabel = formatMessage({ id: 'ga-checkout.address.district' });
        postcodeLabel = formatMessage({ id: 'ga-checkout.address.postcode' });
        stateLabel = formatMessage({ id: 'ga-checkout.address.state' });
        // 设置巴西
        setMyCardCountry(value);
        // line1Label = 'Address';
        // line2Label = 'House number';
        // districtLabel = 'District';
        // cityLabel = 'City';
        // postcodeLabel = 'Postcode';
        // stateLabel = 'State';
      // } else {
      //   setMyCardCountry(value);
      // }

      // 邮编正则匹配
        for (let i = 0; i < postalCodeData.length; i++) {
          if (postalCodeData[i].territoryId === value) {
            setPostcodeRegex(postalCodeData[i].regex);
          }
        }
      

      // setLine1Label(line1Label);
      // setLine2Label(line2Label);
      // setCityLabel(cityLabel);
      // setPostcodeLabel(postcodeLabel);
      // setSelectLabel(selectLabel);
      // setStateLabel(stateLabel);
      // if (!_.isEmpty(countryLabel)) {
      //   setCountryLabel(countryLabel);
      //   // 动态改变子组件中的label样式
      //   setRefChange(countryRef);
      // }
      if (!_.isEmpty(line1Label)) {
        setLine1Label(line1Label);
        // 动态改变子组件中的label样式
        setRefChange(line1Ref);
      }
      if (!_.isEmpty(line2Label)) {
        setLine2Label(line2Label);
        setRefChange(line2Ref);
      }

      if (!_.isEmpty(districtLabel)) {
        setDistrictLabel(districtLabel);
        setRefChange(districtRef);
      }

      if (!_.isEmpty(cityLabel)) {
        setCityLabel(cityLabel);
        setRefChange(cityRef);
      }
      if (!_.isEmpty(postcodeLabel)) {
        setPostcodeLabel(postcodeLabel);
        setRefChange(postcodeRef);
      }
      if (!_.isEmpty(selectLabel)) {
        setSelectLabel(selectLabel);
        setRefChange(stateRef);
      }
      if (!_.isEmpty(stateLabel)) {
        setStateLabel(stateLabel);
        setRefChange(stateRef);
      }
      if (!_.isEmpty(stateList)) {
        const isFindState = _.find(stateList, function(o) {
          return o.$id === cardState;
        });
        if (_.isEmpty(isFindState)) {
          // 如果没找到
          form.setFieldsValue({
            cardState: '',
          });
          setRefChange(stateRef);
        }
        setStateList(stateList);
      }
      if (!_.isEmpty(cityList)) {
        // 判断传的城市是不是乱七八糟的，能否对应上
        const isFindCity = _.find(cityList, function(o) {
          return o.$id === cardCity;
        });
        if (_.isEmpty(isFindCity)) {
          // 如果没找到
          form.setFieldsValue({
            cardCity: '',
          });
          setRefChange(cityRef);
        }
        setCityList(cityList);
      }
      if (!_.isEmpty(validationError)) {
        setValidationError(validationError);
      }
      // 地址通过key转换成Value形式
      setMyAddress(stateList, cityList);
    }
  };

  const setMyAddress = (stateList, cityList) => {
    let myAddress = '';
    if (!_.isEmpty(cardLine1)) {
      myAddress += cardLine1 + ', ';
    }
    if (!_.isEmpty(cardLine2)) {
      myAddress += cardLine2 + ', ';
    }

    if (!_.isEmpty(cityList)) {
      cityList.forEach(item => {
        if (item.$id === cardCity) {
          myAddress += item.$elt + ', ';
        }
      });
    } else {
      if (!_.isEmpty(cardCity)) {
        myAddress += cardCity + ', ';
      }
    }

    if (!_.isEmpty(stateList)) {
      stateList.forEach(item => {
        if (item.$id === cardState) {
          myAddress += item.$elt + ', ';
        }
      });
    } else {
      if (!_.isEmpty(cardState)) {
        myAddress += cardState + ', ';
      }
    }

    if (!_.isEmpty(paypalAddress.territory)) {
      const list = paypalAddress.territory;
      list.forEach(item => {
        if (item.code === cardCountry) {
          myAddress += item.name + ', ';
        }
      });
    }

    myAddress += cardPostcode ? cardPostcode : '';
    setMyAllAddress(myAddress);
  };
  // 国家选择之后触发后续label等的变化
  const handleCountryChange = e => {
    form.resetFields([
      'cardLine1',
      'cardLine2',
      'cardDistrict',
      'cardCity',
      'cardState',
      'cardPostcode',
    ]); // 触发表单校验
    const value = e.target.value;
    // console.log('value', value);
    resetAll();
    setAllLabelValue(value);
  };
  // 动态改变label的值
  const setRefChange = cref => {
    // console.log(cref.current);
    if (!_.isEmpty(cref.current)) {
      cref.current.setLabelClass();
    }
  };
  useImperativeHandle(props.cref, () => ({
    // changeVal 就是暴露给父组件的方法
    clickEdit: () => {
      clickEdit();
    },
    fillFormCountryChange: (country) => {
      setAllLabelValue(country);
    },
    // 动态改变label的值
    setRefChange: cref => {
      setRefChange(cref);
    },
  }));
  // 父组件调用或者本组件自身调用显示具体地址的方法
  const clickEdit = () => {
    setAddressEditable(true);
    setRefChange(countryRef);
    setRefChange(line1Ref);
    setRefChange(line2Ref);
    setRefChange(districtRef);
    setRefChange(cityRef);
    setRefChange(stateRef);
    setRefChange(postcodeRef);
  };

  // 埋点开始
  const onBlurCardCountry = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入国家']);
    gtag(`${showDomain}支付页面`, ['输入国家']);
    showDomain ? gtag(`定制支付页面`, ['输入国家']):'';


  };
  const onBlurCardLine1 = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入地址1']);
    gtag(`${showDomain}支付页面`, ['输入地址1']);
    showDomain ? gtag(`定制支付页面`, ['输入地址1']):'';
  };
  const onBlurCardLine2 = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入地址2']);
    gtag(`${showDomain}支付页面`, ['输入地址2']);
    showDomain ? gtag(`定制支付页面`, ['输入地址2']):'';
  };
  const onBlurCardDistrict = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入区域']);
    gtag(`${showDomain}支付页面`, ['输入区域']);
    showDomain ? gtag(`定制支付页面`, ['输入区域']):'';
  };
  const onBlurCardCity = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入城市']);
    gtag(`${showDomain}支付页面`, ['输入城市']);
    showDomain ? gtag(`定制支付页面`, ['输入城市']):'';
  };
  const onBlurCardState = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入州']);
    gtag(`${showDomain}支付页面`, ['输入州']);
    showDomain ? gtag(`定制支付页面`, ['输入州']):'';
  };
  const onBlurCardPostcode = async function(e) {
    // todo @埋点
    gtag(`${showDomain}支付页面`, [new Date() + '输入邮编']);
    gtag(`${showDomain}支付页面`, ['输入邮编']);
    showDomain ? gtag(`定制支付页面`, ['输入邮编']):'';
  };

  // 埋点结束
  return (
    // 如果国家信息完整的情况，则隐藏
    <div style={{ display: hideAllAddress ? 'none' : 'block' }}>
      {myNeedBillingAddress ? (
        <div className="h5pc-address">
          <Row
            gutter={20}
            style={{ display: !addressEditable ? 'block' : 'none' }}
          >
            <Col span={24}>
              <div className="h5-address-edit">
                <div className="h5-address-edit-label">
                  {/* Address */}
                  {formatMessage({ id: 'ga-checkout.billing-address' })}
                </div>
                <div className="h5-address-edit-text">{myAllAddress}</div>
                <div className="h5-address-edit-btn" onClick={clickEdit}>
                  {/* Edit */}
                  {formatMessage({ id: 'ga-checkout.address.edit' })}
                </div>
              </div>
            </Col>
          </Row>
          <div style={{ display: addressEditable ? 'block' : 'none' }}>
            <Row gutter={20} className="h5pc-address-mb10">
              <Col span={24}>
                <span className="h5-address-title">
                  {formatMessage({ id: 'ga-checkout.billing-address' })}
                </span>
                <FloatLabel
                  form={form}
                  name="cardCountry"
                  cref={countryRef}
                  // label="Country/Region"
                  // label={countryLabel || 'Country/Region'}
                  label={formatMessage({ id: 'ga-checkout.address.country' })}
                  rules={[
                    {
                      required: true,
                      // message: `Please enter your Country/Region.`,
                      message: formatMessage({
                        id: 'ga-checkout.address.placeholder.country',
                      }),
                    },
                  ]}
                >
                  <select
                    className="my-native-select"
                    onChange={handleCountryChange}
                    onBlur={onBlurCardCountry}
                  >
                    {/* United States, Canada, United Kingdom, France, Australia, Germany */}
                    <option disabled="disabled"></option>
                    {paymentMethod !== 'kba' && (
                      <>
                        <option value="US">United States</option>
                        <option value="CA">Canada</option>
                        <option value="GB">United Kingdom</option>
                        <option value="FR">France</option>
                        <option value="AU">Australia</option>
                        <option value="DE">Germany</option>
                        <option value="BR">Brazil</option>
                        <option disabled="disabled">--</option>
                      </>
                    )}
                    {countryList.map(country => {
                      return (
                        <option value={country.code} key={country.code}>
                          {country.name}
                        </option>
                      );
                    })}
                  </select>
                </FloatLabel>
              </Col>
            </Row>
            {!_.isEmpty(line1Label) || !_.isEmpty(myCardLine1) ? (
              <Row gutter={20} className="h5pc-address-mb10">
                <Col span={24}>
                  <FloatLabel
                    form={form}
                    name="cardLine1"
                    cref={line1Ref}
                    label={line1Label}
                    rules={[
                      {
                        required: true,
                        // message: `Please enter your ${line1Label}.`,
                        message:
                          // myCardCountry === 'BR' ?
                            formatMessage({
                                id: 'ga-checkout.address.placeholder.line1',
                              })
                            // : `${formatMessage({
                            //     id: 'ga-checkout.please-enter-your',
                            //   })} ${line1Label}.`,
                      },
                    ]}
                  >
                    <Input
                      size="large"
                      maxLength={256}
                      onBlur={onBlurCardLine1}
                      // placeholder={line1Label}
                    />
                  </FloatLabel>
                </Col>
              </Row>
            ) : null}

            {!_.isEmpty(line2Label) || !_.isEmpty(myCardLine2) ? (
              <Row gutter={20} className="h5pc-address-mb10">
                <Col span={24}>
                  <FloatLabel
                    form={form}
                    name="cardLine2"
                    label={line2Label}
                    cref={line2Ref}
                    className="ant-form-item-required"
                    // rules={[
                    //   {
                    //     required:
                    //       myCardCountry === 'BR' &&
                    //       (type === 'pix' || type === 'bol')
                    //         ? true
                    //         : false,
                    //     // message: `Please enter your ${line2Label}.`,
                    //     message:
                    //       myCardCountry === 'BR'
                    //         ? formatMessage({
                    //             id: 'ga-checkout.address.placeholder.line2',
                    //           })
                    //         : `${formatMessage({
                    //             id: 'ga-checkout.please-enter-your',
                    //           })} ${line2Label}.`,
                    //   },
                    // ]}
                  >
                    <Input
                      size="large"
                      maxLength={256}
                      onBlur={onBlurCardLine2}
                      // placeholder={line2Label}
                    />
                  </FloatLabel>
                </Col>
              </Row>
            ) : null}
            {myCardCountry === 'BR' ? (
              <Row gutter={20} className="h5pc-address-mb10">
                <Col span={24}>
                  <FloatLabel
                    form={form}
                    name="cardDistrict"
                    label={districtLabel}
                    cref={districtRef}
                    className="ant-form-item-required"
                    rules={[
                    //   {
                    //     required: myCardCountry === 'BR' ? true : false,
                    //     // message: `Please enter your ${districtLabel}.`,
                    //     message:
                    //       myCardCountry === 'BR'
                    //         ? formatMessage({
                    //             id: 'ga-checkout.address.placeholder.district',
                    //           })
                    //         : `${formatMessage({
                    //             id: 'ga-checkout.please-enter-your',
                    //           })} ${districtLabel}.`,
                    //   },
                    ({ getFieldValue }) => ({
                      validator: async (rule, value) => {
                        if (_.isEmpty(value)) return;
                        if (['lcr', 'pix', 'bol'].indexOf(type)>-1) {
                          if (!/^[a-zA-Z\-\.\'\s\u00C0-\u00FF]+$/g.test(value)) {                                                          
                            return Promise.reject(
                              formatMessage({
                                id: 'ga-checkout.address.Brazil-tip-cardCity',
                              }),
                            );
                          }
                        }                                              
                      },
                    }), 
                    ]}
                  >
                    <Input
                      size="large"
                      maxLength={['lcr','pix','bol'].indexOf(type)>-1 ? 100 : 64}
                      onBlur={onBlurCardDistrict}
                      // placeholder={line2Label}
                    />
                  </FloatLabel>
                </Col>
              </Row>
            ) : null}
            {!_.isEmpty(cityLabel) || !_.isEmpty(myCardCity) ? (
              <Row gutter={20} className="h5pc-address-mb10">
                <Col span={24}>
                  <FloatLabel
                    form={form}
                    name="cardCity"
                    label={cityLabel}
                    cref={cityRef}
                    rules={[
                      {
                        required: true,
                        // message: `Please enter your ${cityLabel}.`,
                        message:
                          myCardCountry === 'BR'
                            ? formatMessage({
                                id: 'ga-checkout.address.placeholder.city',
                              })
                            : `${formatMessage({
                                id: 'ga-checkout.please-enter-your',
                              })} ${cityLabel}.`,
                      },
                      ({ getFieldValue }) => ({
                        validator: async (rule, value) => {
                          if (localStorage.getItem('paymentMethod') === 'icr' && value.replace(/(\d|\s)/g, '') === '' && value != '') {
                            return Promise.reject(
                              formatMessage({
                                id: 'ga-checkout.city-all-number',
                              }),
                            );
                          };
                          if (_.isEmpty(value)) return;
                          if (['lcr', 'pix', 'bol'].indexOf(type)>-1) {
                            if (!/^[a-zA-Z\-\.\'\s\u00C0-\u00FF]+$/g.test(value)) {                                                          
                              return Promise.reject(
                                formatMessage({
                                  id: 'ga-checkout.address.Brazil-tip-cardCity',
                                }),
                              );
                            }
                          }                                              
                        },
                      }),                      
                    ]}
                  >
                    {!_.isEmpty(cityList) ? (
                      <select
                        className="my-native-select"
                        onBlur={onBlurCardCity}
                        //  onChange={handleCountryChange}
                      >
                        <option disabled="disabled"></option>
                        {/*城市选项*/}
                        {cityList.map(state => {
                          return (
                            <option value={state.$id} key={state.$id}>
                              {state.$elt}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <Input
                        size="large"
                        maxLength={['lcr','pix','bol'].indexOf(type)>-1 ? 100 : 64}
                        onBlur={onBlurCardCity}
                        // placeholder={cityLabel}
                      />
                    )}
                  </FloatLabel>
                </Col>
              </Row>
            ) : null}

            {!_.isEmpty(stateLabel) || !_.isEmpty(myCardState) ? (
              <Row gutter={20} className="h5pc-address-mb10">
                <Col span={24}>
                  <FloatLabel
                    form={form}
                    name="cardState"
                    label={stateLabel}
                    cref={stateRef}
                    rules={[
                      {
                        required: true,
                        // message: `Please enter your ${stateLabel}.`,
                        message:
                          myCardCountry === 'BR'
                            ? formatMessage({
                                id: 'ga-checkout.address.placeholder.state',
                              })
                            : `${formatMessage({
                                id: 'ga-checkout.please-enter-your',
                              })} ${stateLabel}.`,
                      },
                    ]}
                  >
                    {!_.isEmpty(stateList) ? (
                      <select
                        className="my-native-select"
                        onBlur={onBlurCardState}
                      >
                        <option disabled="disabled"></option>
                        {stateList.map(state => {
                          return (
                            <option value={state.$id} key={state.$id}>
                              {state.$elt}
                            </option>
                          );
                        })}
                      </select>
                    ) : (
                      <Input
                        size="large"
                        maxLength={64}
                        onBlur={onBlurCardState}
                        //  placeholder={stateLabel}
                      />
                    )}
                  </FloatLabel>
                </Col>
              </Row>
            ) : null}
            {type === 'icr' ? (
              <>
                {!_.isEmpty(postcodeLabel) ||
                (!_.isEmpty(myCardPostcode) &&
                  //不能包含特殊国家
                  !specialAllCountryArr.includes(cardCountry) &&
                  hideOtherLabel) ? (
                  <Row gutter={20} className="h5pc-address-mb10 CAUS">
                    <Col span={24}>
                      <FloatLabel
                        form={form}
                        name="cardPostcode"
                        label={postcodeLabel}
                        cref={postcodeRef}
                        rules={[
                          {
                            required: true,
                            // message: `Please enter your ${postcodeLabel}.`,
                            message:
                              myCardCountry === 'BR'
                                ? formatMessage({
                                    id:
                                      'ga-checkout.address.placeholder.postcode',
                                  })
                                : `${formatMessage({
                                    id: 'ga-checkout.please-enter-your',
                                  })} ${postcodeLabel}.`,
                          },
                          {
                            pattern:
                              !_.isEmpty(postcodeRegex) &&
                              (myCardCountry === 'US' || myCardCountry === 'CA')
                                ? new RegExp(`^${postcodeRegex}$`, 'g')
                                : '',
                            message:
                              !_.isEmpty(validationError) &&
                              (myCardCountry === 'US' || myCardCountry === 'CA')
                                ? validationError
                                : formatMessage({
                                    id:
                                      'ga-checkout.address.placeholder.correct-postcode',
                                  }),
                          },
                        ]}
                        getValueFromEvent={e => {
                          let val = e.target.value;
                          const country = form.getFieldValue('cardCountry');
                          if (country === 'US') {
                            // 特殊处理，只有US（美国）以此方式
                            // 如果是美国的zipcode，用户在输入第6位的时候，自动在第5位后加入掩码“-”，如果删除第6位，自动删除“-”。
                            let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                            if (/^\d{1,}$/g.test(newVal)) {
                              // && newVal.indexOf('-') > -1
                              if (newVal.length >= 6) {
                                newVal =
                                  newVal.substr(0, 5) + '-' + newVal.substr(5);
                              }
                              form.setFieldsValue({ cardPostcode: newVal });
                              setBeforePostcodeVal(
                                form.getFieldValue('cardPostcode'),
                              ); // 塞入最后一次的值
                              e.target.value = newVal;
                              return e.target.value;
                            } else {
                              return e.target.value;
                            }
                          } else {
                            return e.target.value;
                          }
                        }}
                      >
                        <Input
                          size="large"
                          maxLength={10}
                          onBlur={onBlurCardPostcode}
                          //  placeholder={postcodeLabel}
                        />
                      </FloatLabel>
                    </Col>
                  </Row>
                ) : (
                  // 处理特殊的邮编
                  // United Arab Emirates --> AE 邮编为00000
                  // Qatar --> QA 邮编为00000
                  // Zimbabwe --> ZW 邮编为00000
                  // Hong Kong SAR China --> HK A999077
                  <FloatLabel
                    form={form}
                    label={postcodeLabel}
                    name="cardPostcode"
                    cref={postcodeRef}
                    style={{ display: 'none' }}
                  >
                    <Input
                      size="large"
                      maxLength={9}
                      //  placeholder={postcodeLabel}
                    />
                  </FloatLabel>
                )}
              </>
            ) : (
              <>
                {!_.isEmpty(postcodeLabel) ||
                (!_.isEmpty(myCardPostcode) &&
                  //不能包含特殊国家
                  !specialAllCountryArr.includes(cardCountry) &&
                  hideOtherLabel) ? (
                  <Row gutter={20} className="h5pc-address-mb10 99999">
                    <Col span={24}>
                      <FloatLabel
                        form={form}
                        name="cardPostcode"
                        label={postcodeLabel}
                        cref={postcodeRef}
                        rules={[
                          {
                            required: true,
                            // message: `Please enter your ${postcodeLabel}.`,
                            message:
                              myCardCountry === 'BR'
                                ? formatMessage({
                                    id:
                                      'ga-checkout.address.placeholder.postcode',
                                  })
                                : `${formatMessage({
                                    id: 'ga-checkout.please-enter-your',
                                  })} ${postcodeLabel}.`,
                          },
                          {
                            pattern: !_.isEmpty(postcodeRegex)
                              ? new RegExp(`^${postcodeRegex}$`, 'g')
                              : '',
                            message: !_.isEmpty(validationError)
                              ? validationError
                              : formatMessage({
                                  id:
                                    'ga-checkout.address.placeholder.correct-postcode',
                                }),
                          },
                        ]}
                        getValueFromEvent={e => {
                          let val = e.target.value;
                          const country = form.getFieldValue('cardCountry');
                          if (country === 'US') {
                            // 特殊处理，只有US（美国）以此方式
                            // 如果是美国的zipcode，用户在输入第6位的时候，自动在第5位后加入掩码“-”，如果删除第6位，自动删除“-”。
                            let newVal = val.replace(/[^0-9]/gi, ''); // 替换字符串中的所有的非数字
                            if (/^\d{1,}$/g.test(newVal)) {
                              // && newVal.indexOf('-') > -1
                              if (newVal.length >= 6) {
                                newVal =
                                  newVal.substr(0, 5) + '-' + newVal.substr(5);
                              }
                              form.setFieldsValue({ cardPostcode: newVal });
                              setBeforePostcodeVal(
                                form.getFieldValue('cardPostcode'),
                              ); // 塞入最后一次的值
                              e.target.value = newVal;
                              return e.target.value;
                            }
                          } else {
                            return e.target.value;
                          }
                        }}
                      >
                        <Input
                          size="large"
                          maxLength={10}
                          onBlur={onBlurCardPostcode}
                          //  placeholder={postcodeLabel}
                        />
                      </FloatLabel>
                    </Col>
                  </Row>
                ) : (
                  // 处理特殊的邮编
                  // United Arab Emirates --> AE 邮编为00000
                  // Qatar --> QA 邮编为00000
                  // Zimbabwe --> ZW 邮编为00000
                  // Hong Kong SAR China --> HK A999077
                  <FloatLabel
                    form={form}
                    label={postcodeLabel}
                    name="cardPostcode"
                    cref={postcodeRef}
                    style={{ display: 'none' }}
                  >
                    <Input
                      size="large"
                      maxLength={9}
                      //  placeholder={postcodeLabel}
                    />
                  </FloatLabel>
                )}
              </>
            )}
          </div>
        </div>
      ) : null}
    </div>
  );
};

export default injectIntl(Address);
